// @ts-strict-ignore
import React, { FC } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { IonGrid, IonRow, IonText } from '@ionic/react'
import strings from 'mobile_web/strings'
import { getDirMode } from '../../../platform'
import SectionHeader from './SectionHeader'
import { ScreenSection } from 'mytours-read-common'
import '../styles/sectionQuizScore.less'
import db from 'mobile_web/modules/db'

interface SectionQuizScoreProps {
	section: ScreenSection
}

const SectionQuizScore: FC<SectionQuizScoreProps> = ({ section }) => {
	const { quiz_id } = section
	const questionsLength = useLiveQuery(() => db.quizQuestions.where({ quiz_id }).count())
	const correctAnswersLength = useLiveQuery(() =>
		db.quizResults.filter(res => res.quiz_id === quiz_id && res.correct).count(),
	)

	return (
		<IonGrid className="section-quiz-score" dir={getDirMode()}>
			<SectionHeader title={strings.quiz_score_section_title} />
			<IonRow className="block-content" data-cy="story-screen-section-content">
				<div className="score-wrap">
					<div>
						<i className="fal fa-award" />
					</div>
					<div className="text-wrap">
						<IonText>{strings.quiz_score_section_score_label}</IonText>
						<IonText className="-large">{`${correctAnswersLength} / ${questionsLength}`}</IonText>
					</div>
				</div>
			</IonRow>
		</IonGrid>
	)
}

export default SectionQuizScore
